import { DeploymentLevel } from '@mojility/coach-core';

const Features = {
  'invite_to_workspace': DeploymentLevel.Development,
  'archive_completed_investigation': DeploymentLevel.Production,
  'purchase_in_workspace': DeploymentLevel.UAT,
  'organizations': DeploymentLevel.Development,
  'workspace_analyses': DeploymentLevel.Development,
  'view_all_investigations': DeploymentLevel.Development
};

export default Features;